import { render, staticRenderFns } from "./relatorioFilial.vue?vue&type=template&id=3229efb8"
import script from "./relatorioFilial.vue?vue&type=script&lang=js"
export * from "./relatorioFilial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports